import thunk from 'redux-thunk';
import reducers from '../reducers';
import { applyMiddleware, compose, createStore } from 'redux';
import createHistory from 'history/createBrowserHistory';

let store;
const history = createHistory();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function configureStore(initialState) {
    store = createStore(
        reducers,
        initialState,
        composeEnhancers(applyMiddleware(thunk))
    );

    return store;
}
export { history, store };



// WEBPACK FOOTER //
// ./src/store/index.js